import { Reducer } from 'redux'
import Moment from 'moment'

import {
  IFormulaireState,
  CFormulaireInitial,
  FormulaireActionTypes,
  IRightHolders,
  CMusicInfoInitial,
  IFormulaireList,
  CFormulaireListInitialState,
  CMusicGemaType,
  IMusicInfoGema,
  FormulairesResponse,
  formulairesEmpty,
  Formulaire,
  Music,
  RightHolder,
} from './Types'
import {
  ESpotDetailsSource,
  IFingerprintBucketPair,
  SPOT_STATUS_GERMANY,
} from '../SpotDetails/Types';
import { isNullOrUndefined } from '../../Utils/Various'
import { dateDiff } from '../../Utils/Time'

function retrieveArppCodes(identicSpots: any) {
  let results = ''
  if (!identicSpots) {
    return results
  }
  for (let i = 0; i < identicSpots.length; i += 1) {
    let spot = identicSpots[i]
    if (
      spot.hasOwnProperty('clearance_metadata') &&
      spot.clearance_metadata !== null
    ) {
      results +=
        spot.clearance_metadata.clearance_decision.clearance_decision_number
    }
    if (i < identicSpots.length - 1) {
      results += ', '
    }
  }
  return results
}

function retrievePubIdCodes(identicSpots: any) {
  let results = ''
  if (!identicSpots) {
    return results
  }
  for (let i = 0; i < identicSpots.length; i += 1) {
    let spot = identicSpots[i]
    let filmid_label = spot.filmid_label
    results += filmid_label
    if (i < identicSpots.length - 1) {
      results += ', '
    }
  }
  return results
}

const reducer: Reducer<IFormulaireState> = (
  state = CFormulaireInitial,
  action
) => {
  switch (action.type) {
    case FormulaireActionTypes.FETCH_FORMULAIRE: {
      return CFormulaireInitial
    }
    case FormulaireActionTypes.FETCH_FORMULAIRE_SUCCESS_PDF: {
      return {
        ...state,
        isLoading: false,
        isReceived: true,
        formulairesPDF: action.payload,
      }
    }

    case FormulaireActionTypes.FETCH_FORMULAIRE_FAILURE_PDF: {
      return {
        ...state,
        isLoading: false,
        isReceived: true,
        formulairesPDF: undefined,
      }
    }
    case FormulaireActionTypes.FETCH_FORMULAIRE_SUCCESS: {
      let formulaire = action.payload[0]
      let country = 'fr';
      return {
        ...state,
        [country as keyof IFormulaireState]: { ...formulaire },
        isLoading: false,
        isReceived: true,
      }
    }
    case FormulaireActionTypes.SAVE_FORMULAIRE_START: {
      return {
        ...state,
        isSaving: true,
      }
    }

    case FormulaireActionTypes.SAVE_FORMULAIRE_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    case FormulaireActionTypes.SAVE_FORMULAIRE_SUCCESS: {
      let formulaire = action.payload[0]
      let country = 'fr';

      return {
        ...state,
        [country as keyof IFormulaireState]: { ...formulaire },
        isSaving: false,
      }
    }

    // For France only
    case FormulaireActionTypes.SET_MEDIA_NAME: {
      if (action.payload) {
        return {
          ...state,
          ['fr' as keyof IFormulaireState]: {
            ...state['fr'],
            media: action.payload.name,
          },
        };
      }
      return state
    }
    case FormulaireActionTypes.GET_FORMULAIRE_PREVIEW_SUCCESS: {
      let regroupingId = action.payload[0] as string;
      let bucketId = action.payload[1];
      let result = action.payload[2];
      let media = action.payload[5];
      let identicSpots = action.payload[6];
      let country = action.payload[7];
      const arpp_codes = retrieveArppCodes(identicSpots);
      const pub_id_codes = retrievePubIdCodes(identicSpots);
      const userInfo = action.payload[3];
      const fingerprint_list = action.payload[4] as IFingerprintBucketPair[];
      let first_broadcast = '';
      let musics: any[] = [];
      if (result && result.length > 0) {
        result = result[0];
      }
      const master_filepath = result.master_filepath;
      const master_video_filepath = result.master_video_filepath || '';
      let newState = { ...state };
      let broadcast: any = null;
      if (
        bucketId === ESpotDetailsSource.KANTAR ||
        bucketId === ESpotDetailsSource.FR_RADIO
      ) {
        broadcast = result.broadcast;
      }
      if (result.group && result.group.broadcasts) {
        broadcast = result.group.broadcasts[0];
      }
      if (broadcast !== undefined && broadcast !== null) {
        first_broadcast = broadcast.start_date;
      }
      if (
        result.group &&
        result.group.music_broadcasts &&
        result.group.music_broadcasts.length > 0
      ) {
        musics = result.group.music_broadcasts.filter(
          (x: any) => x.music_state !== 'DELETED'
        );
        musics = musics.map((music: any) => {
          let rightHolders: IRightHolders[] = [];
          let rightHoldersDict: any = {};

          if (
            music.artist !== undefined &&
            music.artist !== null &&
            music.artist !== ''
          ) {
            const persons = music.artist
              .split(',')
              .map((person: string) => person.trim());
            for (let i = 0; i < persons.length; i += 1) {
              if (rightHoldersDict.hasOwnProperty(persons[i])) {
                rightHoldersDict[persons[i]].roles.push('artist');
              } else {
                rightHoldersDict[persons[i]] = {
                  name: persons[i],
                  roles: ['artist'],
                };
              }
            }
          }

          if (
            music.composers !== undefined &&
            music.composers !== null &&
            music.composers !== ''
          ) {
            const persons = music.composers
              .split(',')
              .map((person: string) => person.trim());
            for (let i = 0; i < persons.length; i += 1) {
              if (rightHoldersDict.hasOwnProperty(persons[i])) {
                rightHoldersDict[persons[i]].roles.push('composer');
              } else {
                rightHoldersDict[persons[i]] = {
                  name: persons[i],
                  roles: ['composer'],
                };
              }
            }
          }
          if (
            music.authors !== undefined &&
            music.authors !== null &&
            music.authors !== ''
          ) {
            const persons = music.authors
              .split(',')
              .map((person: string) => person.trim());
            for (let i = 0; i < persons.length; i += 1) {
              if (rightHoldersDict.hasOwnProperty(persons[i])) {
                rightHoldersDict[persons[i]].roles.push('author');
              } else {
                rightHoldersDict[persons[i]] = {
                  name: persons[i],
                  roles: ['author'],
                };
              }
            }
          }

          for (const [key, value] of Object.entries(rightHoldersDict)) {
            rightHolders.push(value as IRightHolders);
          }
          let usage_duration =
            parseInt(music.end_time) - parseInt(music.start_time);
          return {
            title: music.title,
            usage_duration,
            type: null,
            code_isrc: music.isrc,
            code_iswc: music.iswc,
            code: '',
            right_holders: rightHolders,
          };
        });
      } else {
        musics = [CMusicInfoInitial];
      }

      let marque = '';
      let product_name = '';
      let agency = '';
      let spot_title = '';
      let duration: any = '';

      if (
        result.hasOwnProperty('creative_agency_metadata') &&
        result.creative_agency_metadata !== null
      ) {
        if (
          result.creative_agency_metadata.hasOwnProperty('advertiser') &&
          result.creative_agency_metadata.advertiser !== null
        ) {
          marque = result.creative_agency_metadata.advertiser.internal_name;
        }
        if (
          result.creative_agency_metadata.hasOwnProperty('product') &&
          result.creative_agency_metadata.product !== null
        ) {
          product_name = result.creative_agency_metadata.product.internal_name;
        }
        if (
          result.creative_agency_metadata.hasOwnProperty('creative_agency') &&
          result.creative_agency_metadata.creative_agency !== null
        ) {
          agency =
            result.creative_agency_metadata.creative_agency.internal_name;
        }
        spot_title = result.creative_agency_metadata.title;
        if (
          !isNullOrUndefined(result.creative_agency_metadata) &&
          result.creative_agency_metadata.duration
        ) {
          duration = result.creative_agency_metadata.duration;
        } else if (broadcast !== null && broadcast !== undefined) {
          duration = dateDiff(
            new Date(broadcast.end_date),
            new Date(broadcast.start_date)
          ).sec;
        }
      }

      newState = {
        ...state,
        ['fr' as keyof IFormulaireState]: {
          ...state['fr'],
          diffusion_date: first_broadcast,
          bucket_id: bucketId,
          spot_id:
            bucketId === ESpotDetailsSource.KANTAR ||
            bucketId === ESpotDetailsSource.FR_RADIO
              ? result.broadcast.id
              : result.id,
          fingerprint_list,
          regrouping_id: regroupingId,
          master_filepath,
          master_video_filepath,
          marque: marque,
          country: 'fr',
          codes_arpp: arpp_codes,
          codes_pub_id: pub_id_codes,
          product_name: product_name,
          agency: agency,
          spot_title: spot_title,
          duration: duration,
          media: media,
          music: musics,
          society: {
            id: userInfo.id,
            name: userInfo.firstname,
            surname: userInfo.name,
            email: userInfo.email,
            date: new Date().toISOString().substring(0, 10),
            user_group_info: userInfo.parent_info,
            signature: '',
          },
          diffuser: media.name,
        },
      };
      //newState = {...state}

      return newState;
    }

    case FormulaireActionTypes.GET_FORMULAIRE_PREFILL: {
      return {
        ...state,
        isLoading: true,
      }
    }
    
    case FormulaireActionTypes.GET_FORMULAIRE_PREFILL_SUCCESS: {
      // Mapper les données reçues vers un formulaire pré-rempli
      const adData = action.payload[0]
      const user = action.payload[1]
      const fgpId = action.payload[2]
      const fingerprint_list = action.payload[3] as IFingerprintBucketPair[]
      const bucketId = action.payload[4]
      console.log('adData', adData)

      let music: Music[] = []
      if (adData.tracks && adData.tracks.length > 0) {
        music = adData.tracks.map((track: any) => {
          let right_holders: RightHolder[] = []
          if (track.artist) {
            right_holders.push({
              name: track.artist,
              roles: ['artist'],
            })
          }
          if (track.composers) {
            right_holders.push({
              name: track.composers,
              roles: ['composer'],
            })
          }
          if (track.authors) {
            right_holders.push({
              name: track.authors,
              roles: ['author'],
            })
          }
          return {
            title: track.title,
            right_holders: right_holders,
            usage_duration: (track.offset_end - track.offset_start),
          }
        })
      }

      let arppCodes = ''
      let pubIdCodes = ''
      if (adData.group_ads.length > 0) {
        for (const groupAd of adData.group_ads) {
          if (groupAd.arpp_code) {
            arppCodes += groupAd.arpp_code + ', '
          }
          if (groupAd.filmid_label) {
            pubIdCodes += groupAd.filmid_label + ', '
          }
        }
      }

      // Créer un formulaire pré-rempli basé sur les données de l'annonce
      const newState = {
        ...state,
        isLoading: false,
        isReceived: true,
        ['fr' as keyof IFormulaireState]: {
          ...state['fr'],
          diffusion_date: adData.ad.first_diffusion,
          duration: adData.ad.duration,
          spot_title: adData.ad.title,
          marque: adData.ad.internal_name,
          product_name: adData.ad.product_code,
          agency: adData.ad.creative_agency_name,
          diffuser: adData.ad.first_diffusion_media.name,
          media: {
            name: adData.ad.first_diffusion_media.name,
            type: bucketId === ESpotDetailsSource.ARPP ? "TV" : "RADIO",
            id: adData.ad.first_diffusion_media.id,
          },
          master_filepath: bucketId === ESpotDetailsSource.ARPP ? adData.ad.filmid_label : adData.ad.id,
          music: music,
          codes_arpp: arppCodes,
          codes_pub_id: pubIdCodes,
          society: {
            id: user.id,
            name: user.firstname,
            surname: user.name,
            email: user.email,
            date: new Date().toISOString().substring(0, 10),
            user_group_info: user.parent_info,
            signature: '',
          },
          fingerprint_list: fingerprint_list,
          bucket_id: bucketId,
          spot_id: fgpId,
          country: 'fr',
        },
      }
      
      return newState
    }
    
    case FormulaireActionTypes.GET_FORMULAIRE_PREFILL_ERROR: {
      return {
        ...state,
        isLoading: false,
        isReceived: false,
      }
    }

    default: {
      return { ...state }
    }
  }
}

const reducerList: Reducer<IFormulaireList> = (
  state = CFormulaireListInitialState,
  action
) => {
  switch (action.type) {
    case FormulaireActionTypes.GET_FORMULAIRE_LIST: {
      return {
        ...state,
        limit: 25,
        page: 1,
        results: [],
        total_count: 0,
        total_pages: 0,
        loadingFormulaireList: true,
        formulaires: formulairesEmpty,
      }
    }
    case FormulaireActionTypes.GET_FORMULAIRE_LIST_SUCCESS: {
      let results = action.payload as FormulairesResponse
      return {
        ...state,
        formulaires: results,
        loadingFormulaireList: false,
      }
    }
    case FormulaireActionTypes.GET_FORMULAIRE_LIST_ERROR: {
      return {
        ...state,
        formulaires: formulairesEmpty,
      }
    }

    case FormulaireActionTypes.EXPORTS_DECLARATIONS: {
      return {
        ...state,
        file_downloaded: null,
      }
    }
    case FormulaireActionTypes.EXPORTS_DECLARATIONS_SUCCESS: {
      return {
        ...state,
        file_downloaded: action.payload,
      }
    }

    case FormulaireActionTypes.CLEAN_FILE_DOWNLOAD: {
      return {
        ...state,
        file_downloaded: null,
      }
    }
    default: {
      return {
        ...state,
      }
    }
  }
}

export { reducer as FormulaireReducer }
export { reducerList as FormulaireListReducer }
